//获取cookie、
export function getCookie(name) {
    var arr,reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    /* eslint-disable */
    if (arr = document.cookie.match(reg))
    /* eslint-enable */
    return (arr[2]);
    else
    return null;
}

//设置cookie,增加到vue实例方便全局调用
export function setCookie (c_name, value, expiredays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + expiredays);
    document.cookie = c_name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString());
}

//删除cookie
export function delCookie (name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = getCookie(name);
    if (cval != null)
    document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
}

//存cookie数组
export function setCookieArr(name,value,day,num) {
    const date = new Date();//用来设置过期时间用的，获取当前时间加上传进来的iDay就是过期时间
    date.setDate(date.getDate() + day);
    const cookieObj = [];
    if(getCookieArr(name) !== null){
        if(getCookieArr(name).split(',').length >= 1) {
            for(let i = 0;i < getCookieArr(name).split(',').length;i++){
                cookieObj.push(getCookieArr(name).split(',')[i]);
            }
        }else{
            cookieObj.push(getCookieArr(name).split(','));
        }
    }
    cookieObj.push(value);
    let arr = unique(cookieObj);//数组去重
    document.cookie = name + '=' + arr + ';expires=' + date;
    if(getCookieArr(name).split(',').length >= num){//设置最多存储多少条数据
        cookieObj.shift()
    }
}

//取出cookie数组
export function getCookieArr(name) {
    if (document.cookie.length>0){
        let start = document.cookie.indexOf(name + "=")
        if (start != -1){
            start = start + name.length + 1;
            let end = document.cookie.indexOf(";",start);
            if (end == -1)  end = document.cookie.length
                return unescape(document.cookie.substring(start,end))
            }
        }
        return null;
  }

//数组去重
const unique = (arr) => {
    // 遍历arr，把元素分别放入tmp数组(不存在才放)
    var tmp = new Array();
    for(var i in arr){
        //该元素在tmp内部不存在才允许追加
        if(tmp.indexOf(arr[i])===-1){
            tmp.push(arr[i]);
        }
    }
    return tmp;
}